import { Component, OnInit, Input } from '@angular/core';
import { iDialogServiceInput } from '../../dialog.service';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

export const MY_FORMATS = {
  ...MAT_DATE_FORMATS,
  display: {
    dateInput: { month: 'short', year: 'numeric' }
  }
};

@Component({
  selector: 'app-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.css'],
  providers: [
    { provide: DateAdapter, useClass: NativeDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class MonthPickerComponent implements OnInit {
  @Input()
  public input: iDialogServiceInput;

  constructor() {}

  ngOnInit() {}

  chosenYearHandler(input: iDialogServiceInput, normalizedYear: Date) {
    const ctrlValue = (input.value as Date) || new Date();
    input.value = new Date(ctrlValue.setFullYear(normalizedYear.getFullYear(), 0, 1));
  }

  chosenMonthHandler(input: iDialogServiceInput, normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    const ctrlValue = (input.value as Date) || new Date();
    input.value = new Date(ctrlValue.setMonth(normalizedMonth.getMonth(), 1));
    datepicker.close();
  }
}
